import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      d="M11.647 15.262h1.992v2c0 .221.065.41.188.574l.041.049.041.041c.148.14.344.205.574.205a.84.84 0 0 0 .869-.869v-2h1.992a.853.853 0 0 0 .623-.238c.164-.156.237-.36.237-.615a.853.853 0 0 0-.237-.623c-.156-.163-.37-.237-.623-.237h-1.992v-1.992a.84.84 0 0 0-.869-.877c-.23 0-.426.065-.574.205l-.04.04-.042.05a.918.918 0 0 0-.188.582v1.992h-1.992c-.263 0-.476.082-.632.237a.84.84 0 0 0-.245.623c0 .255.082.451.245.615a.887.887 0 0 0 .632.238Z"
    />
    <path
      fill="#111"
      d="M20.363 8.455c-.429-.42-1.083-.638-1.932-.638h-2.34V6.43c0-.84-.219-1.478-.647-1.907-.428-.42-1.083-.638-1.93-.638L5.56 3.877c-.848 0-1.503.218-1.931.638-.428.42-.647 1.067-.647 1.907v7.652c0 .84 0 1.603.675 2.265.429.42 1.083.638 1.931.638h2.348l-.028 1.426c0 .84.218 1.479.646 1.907.429.42 1.083.638 1.931.638h7.938c.857 0 1.503-.218 1.932-.638.428-.42.646-1.066.646-1.907v-8.05c0-.84-.218-1.478-.646-1.906l.008.008Zm-5.905-.646-3.973.008c-.848 0-1.502.218-1.93.638-.429.42-.647 1.067-.647 1.907l.028 4.991H5.613c-.315 0-.496-.048-.72-.242-.334-.292-.271-.578-.278-1.102V6.495c0-.331.08-.582.25-.743.162-.162.404-.243.72-.243l7.904.008c.315 0 .55.081.719.243.162.161.25.412.25.743v1.306ZM9.54 10.435c0-.332.081-.582.25-.744.162-.161.405-.242.72-.242h7.897c.315 0 .558.08.72.242.16.162.25.412.25.744v7.887c0 .332-.081.582-.25.744-.162.161-.405.242-.72.242H10.51c-.315 0-.558-.08-.72-.242-.161-.162-.25-.412-.25-.744v-7.887Z"
    />
  </svg>
)
export default SvgComponent
